import React from 'react';
import { Box, TextField, IconButton, CircularProgress } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

/**
 * ReviewerSearchBar — input + magnifying-glass button used in the ผู้รีวิว tab.
 * Pressing Enter or clicking the lens runs the search.
 */
const ReviewerSearchBar = ({
  value,
  onChange,
  onSearch,
  onClear = null,
  loading = false,
  language = 'TH',
  sx = {},
}) => {
  const placeholder = language === 'TH'
    ? 'ค้นหาผู้รีวิว'
    : language === 'CN'
      ? '搜索评论者'
      : 'Search reviewers';

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch(value);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      <TextField
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        size="small"
        fullWidth
        InputProps={{
          endAdornment: value && onClear ? (
            <IconButton size="small" onClick={onClear} sx={{ color: '#999' }} aria-label="Clear reviewer search">
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          ) : null,
        }}
        sx={{
          '& .MuiInputBase-root': {
            height: '40px',
            borderRadius: '20px',
            backgroundColor: '#f5f5f5',
            fontSize: '0.875rem',
          },
          '& fieldset': { border: 'none' },
        }}
      />

      <IconButton
        onClick={() => onSearch(value)}
        disabled={loading}
        aria-label="Search reviewers"
        sx={{
          backgroundColor: '#7c3aed',
          color: '#ffffff',
          width: 40,
          height: 40,
          flexShrink: 0,
          boxShadow: '0 4px 10px rgba(124, 58, 237, 0.25)',
          '&:hover': { backgroundColor: '#6d28d9' },
          '&.Mui-disabled': { backgroundColor: 'rgba(124, 58, 237, 0.4)', color: '#fff' },
        }}
      >
        {loading
          ? <CircularProgress size={18} sx={{ color: '#fff' }} />
          : <SearchIcon sx={{ fontSize: 20 }} />}
      </IconButton>
    </Box>
  );
};

export default ReviewerSearchBar;
